import OverlayTrigger from '@rio-cloud/rio-uikit/OverlayTrigger';
import Tooltip from '@rio-cloud/rio-uikit/Tooltip';
import { useRef, useState } from 'react';
import { NoValue } from '../../../sharedComponents/NoValue';

type DisplaySpecialInstructionsProps = {
    readonly specialInstructions: readonly string[];
};

const isContentOverflowing = (contentElement: HTMLElement | null) =>
    contentElement !== null && contentElement.scrollWidth > contentElement.clientWidth;

export const DisplaySpecialInstructions = ({ specialInstructions }: DisplaySpecialInstructionsProps) => {
    const text = specialInstructions.join(' ').trim();
    const contentRef = useRef<HTMLSpanElement>(null);
    const [showTooltip, setShowTooltip] = useState(false);

    if (text.length === 0) {
        return <NoValue />;
    }

    const content = (
        <span className="display-block">
            <span ref={contentRef} className="display-block ellipsis-1">
                {text}
            </span>
        </span>
    );

    const handleTooltipToggle = (show: boolean) => setShowTooltip(show && isContentOverflowing(contentRef.current));

    return (
        <OverlayTrigger
            placement="top"
            show={showTooltip}
            onToggle={handleTooltipToggle}
            overlay={
                <Tooltip
                    id="special-instructions-tooltip"
                    textAlignment="left"
                    width="auto"
                    innerClassName="max-width-500"
                    allowOnTouch
                >
                    {specialInstructions.map((specialInstruction, index) => (
                        <div key={`${specialInstruction}-${index}`}>{specialInstruction}</div>
                    ))}
                </Tooltip>
            }
        >
            {content}
        </OverlayTrigger>
    );
};
